"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSynchronizeFavoritesUseCase = void 0;
const react_1 = require("react");
const products_1 = require("../../services/products");
const tdcClient_1 = require("../../services/tdcClient");
function useSynchronizeFavoritesUseCase(params) {
    const { businessUnit, favoritesLocalStorageRepository, resellerSlug, onSuccess, onError } = params;
    const enhanceFavorites = (0, react_1.useCallback)((skus) => __awaiter(this, void 0, void 0, function* () {
        const productsService = new products_1.ProductsService(tdcClient_1.tdcClient);
        return yield productsService.getProductsBySkus({
            skus,
            businessUnit,
            page: 1,
            pageSize: skus.length,
            catalogSlug: resellerSlug,
        });
    }), [businessUnit, resellerSlug, businessUnit, resellerSlug, tdcClient_1.tdcClient]);
    return (0, react_1.useCallback)((favoritesRepositoryApiImpl) => __awaiter(this, void 0, void 0, function* () {
        try {
            const favoritesFromLocalStorage = yield favoritesLocalStorageRepository.getAllItems();
            const hasNoItemsToSynchronize = !favoritesFromLocalStorage.length;
            if (hasNoItemsToSynchronize) {
                return;
            }
            const enhancedFavoriteProducts = yield enhanceFavorites(favoritesFromLocalStorage.map((item) => item.sku));
            const couldNotEnhanceSkusWithProductInfo = !enhancedFavoriteProducts.products.length;
            if (couldNotEnhanceSkusWithProductInfo) {
                throw new Error('No products found for the given skus');
            }
            const productsWithSkuAndOrganization = enhancedFavoriteProducts.products
                .filter((item) => item.organization)
                .map((item) => ({
                sku: item.sku,
                organization: item.organization.slugName,
            }));
            yield favoritesRepositoryApiImpl.addItems(productsWithSkuAndOrganization);
            yield favoritesLocalStorageRepository.clearItems();
            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
        }
        catch (error) {
            onError === null || onError === void 0 ? void 0 : onError(error);
        }
    }), [businessUnit, resellerSlug, favoritesLocalStorageRepository, tdcClient_1.tdcClient, onSuccess]);
}
exports.useSynchronizeFavoritesUseCase = useSynchronizeFavoritesUseCase;
